// Currency formatting — single source of truth for Mao Coin display.
// All UI imports from here; changing the symbol or peg later is a one-file edit.

import { MaoCoinConfig } from '../config/balance.js'

const NF = new Intl.NumberFormat('en-US')

// Mao Coin display. Plain integer + `m` suffix. e.g. `1,234m`.
// For values ≥ 1 billion, switches to `b` (e.g. `1.25b`) per the diagram's
// big-amount notation.
export function formatCoins(n) {
  const v = Math.floor(n ?? 0)
  if (v >= 1_000_000_000) {
    const b = v / 1_000_000_000
    const trimmed = b >= 10 ? b.toFixed(1) : b.toFixed(2)
    return `${trimmed.replace(/\.?0+$/, '')}b`
  }
  return `${NF.format(v)}${MaoCoinConfig.symbol}`
}

// Mao Coin → USD view value (number, not string).
export function coinsToUsd(n) {
  return (n ?? 0) * MaoCoinConfig.usdPerCoin
}

// USD display. ≤ $0.01 shows 4 decimals; otherwise 2.
export function formatUsd(usd) {
  if (usd == null || isNaN(usd)) return '—'
  if (Math.abs(usd) < 0.01) return `$${usd.toFixed(4)}`
  if (Math.abs(usd) < 1000) return `$${usd.toFixed(2)}`
  return `$${NF.format(Math.round(usd))}`
}

// Convenience: `formatCoinsWithUsd(n)` → "1,234m (≈ $0.12)" for headline displays.
export function formatCoinsWithUsd(n) {
  return `${formatCoins(n)} (≈ ${formatUsd(coinsToUsd(n))})`
}

// Used by the floating "+Xm" feedback above the paw button — `+` sign + suffix.
export function formatCoinsDelta(n) {
  return `+${formatCoins(n)}`
}

// "Not enough Mao Coin" with the real numbers and what to do about it.
export function cantAfford(what, cost, have) {
  const gap = Math.max(0, Math.round(cost - have))
  return `Not enough Mao Coin to ${what} — it costs ${formatCoins(cost)} and you have ${formatCoins(Math.round(have))} (${formatCoins(gap)} short). Keep clicking the rice to earn the rest.`
}
